import { gql } from '@apollo/client';

export const GET_PRAYER_MEETINGS = gql`
query PrayerMeetings($supportedOrganisationId: Int!) {
  prayerMeetings(supportedOrganisationId: $supportedOrganisationId) {
    id
    name
    location
    time
    frequency
  }
}`;
